import { api, SKIP_AUTO_CONTENT_TYPE_HEADER } from './api';

// Define a service using a base URL and expected endpoints
export const anonymizeApi = api.injectEndpoints({
  reducerPath: 'anonymizeApi',
  tagTypes: ['Anonymize'],
  endpoints: (builder) => ({
    computesWhitelist: builder.mutation({
      query: ({ files, threshold, type }) => {
        const formData = new FormData();
        files.forEach((file) => {
          formData.append(`documents`, file);
        });

        formData.append(
          'request',
          new Blob([JSON.stringify({ tags: ['PER'], threshold: threshold / 100, type })], {
            type: 'application/json'
          })
        );

        return {
          url: `/api/whitelist`,
          method: 'POST',
          formData: true,
          body: formData,
          headers: {
            [SKIP_AUTO_CONTENT_TYPE_HEADER]: 'true'
          }
        };
      }
    })
  })
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useComputesWhitelistMutation } = anonymizeApi;
